import L from 'leaflet';
import eskape from 'eskape';
import { editObject, deleteObject, attachSm } from '../../utils/mapUtils';
import { store } from '../../store';
import { showPopupMenu } from './contextMenu';
import {
  onmouseover,
  onmouseout,
  clickHandler,
  apClickHandler,
} from './featureEvents';
import { isChannel60Ghz } from './leafletCanvas';
import { GREY_COLOR } from 'src/app.constants';

// The SVG colours are restricted to named colours only.
// #f4a460 does work as the fill in some browsers, but
// it may be safer to use the colours from the SVG spec.
const apMarkerSVG = `
<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30'>
<path d='M 15 30, 1 10 C 1 0, 29 0, 29 10 z' fill='#f4a460' stroke='black' stroke-linecap="round" stroke-width="1" />
</svg>`;
const apClusterIcon = encodeURI('data:image/svg+xml,' + apMarkerSVG).replace(
  '#',
  '%23'
);

/**
 * Return the formatting style for the access point cluster markers.
 */
export const apClusterMarker = (feature, latlng) => {
  if (feature.properties.count) {
    const count = feature.properties.count;
    const xscale = 30 + 3 * Math.log(count);
    const yscale = 30 + 3 * Math.log(count);
    const icon = new L.icon({
      iconUrl: apClusterIcon,
      iconSize: [xscale, yscale],
      iconAnchor: [xscale / 2, yscale / 2],
    });
    return L.marker(latlng, { icon: icon });
  }
};

/**
 * Bind events to the access point layer and add the label
 *
 * @param {Object} feature   - GeoJSON feature instance
 * @param {Object} layer     - Leaflet GeoJSON layer instance
 */
export const accessPointEvents = function (feature, layer) {
  let events = {};
  if (!feature.properties.count) {
    events = {
      mouseout: onmouseout,
      mouseover: onmouseover,
      click: apClickHandler,
    };
    if (store.getState().mainFrame.permissionWrite) {
      events = {
        ...events,
        contextmenu: onRightClickAP,
      };
    }
  }
  layer.on(events);

  // Add the marker labels to the layer
  let permanent = false;
  let direction = 'top';
  let label = eskape`${feature.properties.name}`;
  let className = 'siteLabel';
  if (feature.properties.count) {
    // clustered site marker
    permanent = true;
    direction = 'center';
    label = feature.properties.count;
    className = 'clusterLabel';
  }

  layer.bindTooltip(`${label}`, {
    interactive: false,
    opacity: 0.9,
    permanent,
    direction,
    className,
  });
};

const onRightClickAP = (event) => {
  // Call the standard click handler to set the current selection
  clickHandler(event);

  /** Callback function when an item is selected in the menu
   *
   * @callback onClickCallback
   */
  const onclick = (key) => {
    const { kind, id, name } = event.target.feature.properties;
    console.log(key, name);
    if (key === 'edit') {
      editObject(kind, id);
    } else if (key === 'delete') {
      deleteObject(kind, id);
    } else if (key === 'attachSm') {
      attachSm(id);
    }
  };
  // Display the menu
  showPopupMenu(
    event,
    [
      { key: 'edit', content: 'Edit' },
      { key: 'delete', content: 'Delete' },
      { key: 'attachSm', content: 'Attach Subscribers' },
      //   { key: 'delete', content: 'Delete' },
      //   { key: 'attach_sm', content: 'Attach SMs' },
    ],
    onclick
  );
};

export const CHANNEL_1_COLOR = '#9738eb';
export const CHANNEL_2_COLOR = '#4aff2e';
export const CHANNEL_3_COLOR = '#2ef8ff';
export const CHANNEL_4_COLOR = '#ffff00';
export const CHANNEL_AUTO_COLOR = '#4287f5';

/**
 * Return the formatting style for the access points.
 */
export const styleAccessPoint = function (
  feature,
  isSelected = false,
  defaultColor = '#f4a460'
) {
  const strokeWeight = isSelected ? 3 : 1;
  const fillOpacity = isSelected ? 0.8 : 0.2;

  if (!feature.properties.count) {
    let color;
    if (feature.properties.strokeColor == GREY_COLOR) {
      // always grey out dirty APs
      color = feature.properties.strokeColor;
    } else if (isChannel60Ghz()) {
      // always look at radio 0 since each sector is a separate feature
      const channel = feature.properties.radios?.[0].tx_channel ?? 'AUTO';
      if (channel === 'ch_1') {
        color = CHANNEL_1_COLOR;
      } else if (channel === 'ch_2') {
        color = CHANNEL_2_COLOR;
      } else if (channel === 'ch_3') {
        color = CHANNEL_3_COLOR;
      } else if (channel === 'ch_4') {
        color = CHANNEL_4_COLOR;
      } else {
        color = CHANNEL_AUTO_COLOR;
      }
    } else {
      color = feature.properties.strokeColor || defaultColor;
    }

    return {
      color: color,
      weight: strokeWeight,
      fillOpacity: fillOpacity,
      fillColor: color,
    };
  }
};
